import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    systemId: null,
    user: {
      profile: {},
      organization: {},
    },
    isAuthenticated() {
      let d = new Date(0);
      d.setUTCSeconds(this.user.expiration);

      return this.user.uid !== undefined && new Date() < d
    },
    isAdmin () {
      return (this.user.roles !== undefined && this.user.roles.indexOf('Administrator') !== -1)
    },
    isTokenActive () {
      let d = new Date(0);
      d.setUTCSeconds(this.user.expiration);

      return new Date() < d;
    },
  },
  mutations: {
    setUser (state, params) {
      if (params.uid === undefined) {
        return
      }

      state.user = {
        uid: params.uid !== undefined ? params.uid : null,
        username: params.username !== undefined ? params.username : null,
        email: params.email !== undefined ? params.email : null,
        phone: params.phone !== undefined ? params.phone : null,
        token: params.token !== undefined ? params.token : null,
        expiration: params.expiration !== undefined ? params.expiration : null,
        roles: params.roles !== undefined ? params.roles : null,
        profile: params.profile !== undefined && params.profile !== null ? params.profile : {},
        organization: params.organization !== undefined && params.organization !== null ? params.organization : {},
      }
    },
    logOut (state) {
      state.user = {}
    },
    setSystemId (state, params) {
      if (params.systemId === undefined) {
        return
      }

      state.systemId = params.systemId
    },
  },
  actions: {
    user () {
      return this.state.user
    },
  },
  modules: {
  },
  plugins: [createPersistedState()]
})
